import { render } from "./LeaveAttachmentInput.vue?vue&type=template&id=6e0e1bf5"
import script from "./LeaveAttachmentInput.vue?vue&type=script&lang=js"
export * from "./LeaveAttachmentInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__